export default __webpack_public_path__ + "static/media/OpenSans-Regular.b8cc747a.ttf";